import { RouteListParam } from '../tools/public'
import { RoleTypeParam } from '../tools/util'
import Loginpage from '../pages/login'
import Basiclayout from '../pages/basiclayout'
import Goodslist from '../pages/goodslist'
import ToSubmitGoods from '../pages/toSubmitGoods'
import Account from '../pages/account'
import AccountEdit from '../pages/accountedit'
import Goodsdetail from '../pages/goodsmanage/goodsdetail'
import GoodsSubmission from '../pages/materialSubmissionManage'
import GoodsdetailLaun from '../pages/goodsmanage/detailGoods' // 我发起的-编辑
import Goodauditdetail from '../pages/goodsmanage/goodscheck' // 物料信息-详情
import listlaunchgoodsInfo from '../pages/goodsmanage/listlaunchgoodsInfo' // 物料列表-编辑
import Baseinfo from '../pages/baseinfo'
import Password from '../pages/password'
import Home from '../pages/home'
import memberInfo from '../pages/member-info'
import businessInfo from '../pages/business-info'
import financialInfo from '../pages/financial-info'
// import cooperationInfo from '../pages/cooperation'
import qualificationsInfo from '../pages/qualifications'
import contract from '../pages/contract'
import SelfAgreement from '../pages/self-agreement'
import addBrandAuthority from '../pages/add-brand-authority'
import updateBrandAuthority from '../pages/add-brand-authority'
import supplierRegister from '../pages/supplier-register'
import Taskcenter from '../pages/taskcenter'
import Taskdetail from '../pages/taskdetail'
import OrderAssurance from '../pages/orderassurance'
import OrderTransfer from '../pages/ordertransfer/index'
import ReturnManagement from '../pages/returnmanagement'
import OrderRegistration from '../pages/orderregistration'
// import FinancialReconciliation from '../pages/financialreconciliation'
import OrderDetail from '../pages/orderdetail'
import OrderSupplierDetail from '../pages/orderSupplierDetail'
import AddDeliveryOrder from '../pages/orderdetail/components/AddDeliveryOrder'
import AddSupplierDeliveryOrder from '../pages/orderSupplierDetail/components/AddDeliveryOrder'
import DeliveryOrderDetail from '../pages/orderdetail/components/DeliveryOrderDetail'
import FinancialReconciliationDetail from '../pages/financialreconciliationdetail'
import EditFinancialReconciliation from '../pages/financialreconciliationEdit'
import AddFinancialReconciliation from '../pages/financialreconciliationEdit'
import FilingSheet from '../pages/filing-sheet'
import ReturnOrder from '../pages/return-order'
import CancelOrder from '../pages/cancel-order'
import ReturnCancelOrder from '../pages/returnCancelOrder'
import ExpressH5 from '../pages/expressH5'
import MessageCenter from '../pages/messageCenter'
import _ from 'lodash'
import OrderInvoice from '../pages/order-invoice'
import AddInvoice from '../pages/addinvoice'
// 开票申请
import InvoiceApplication from '../pages/invoiceApplication'
// 开票申请详情
import InvoiceApplicationDetail from '../pages/invoiceApplicationDetail'
// import ReconcilableOrders from '../pages/reconcilable-orders'
import PayableOrders from '../pages/payable-orders'
import AddPaymentRequest from '../pages/add-payment-request'
import PaymentReqauest from '../pages/payment-request'
import PaymentRequestDetail from '../pages/payment-request-detail'
import NewBatchAdd from '../pages/new-batchadd'
import AddReportReceipt from '../pages/add-report-receipt'
import SubmitResult from '../pages/submitMaterial'
import MyBrand from '../pages/myBrand' // 我的品牌
import AddBrand from '../pages/brandmanage/branddetail' // 新增品牌
import BrandDetail from '../pages/brandmanage/branddetail' // 品牌详情
import MyLaunch from '../pages/mylaunch' // 我的申请
import EditBrandDetail from '../pages/brandmanage/branddetail' // 修改品牌
import XhNotice from '../pages/xhNotice' // 咸亨公告
import XhNoticeDetail from '../pages/xhNoticeDetail' // 公告详情
import InvoiceEntry from '../pages/InvoiceEntry' // 发票录入页
import MyInvoice from '../pages/MyInvoice' // 我的发票页
import AddInvoiceEntry from '../pages/AddInvoiceEntry' // 新增发票页
import InvoiceDetail from '../pages/AddInvoiceEntry' // 发票详情页
import PaymentDetails from '../pages/PaymentDetails' // 客户回款明细页
import InventoryManagement from '../pages/InventoryManagement' // 库存管理页面
import MaterialPriceAdjustment from '../pages/MaterialPriceAdjustment' // 国网物料调价页
import PendingInvoicePage from '@/pages/pendingInvoicePage'
import RedNoticePage from '@/pages/redNoticePage'
import OrganizationSettings from '@/pages/organizationSettings'

import MaterialSubmission from '../pages/materialSubmission'
import RedInvoiceEntry from '@/pages/RedInvoiceEntry'
import AddRedInvoiceEntry from '@/pages/AddRedInvoiceEntry'
import RedInvoiceDetail from '@/pages/RedInvoiceDetail'

import XhQuotation from '@/pages/XhQuotation'
import InquiryDetail from '@/pages/inquiryDetail'
import TodoList from '@/pages/todoList'
import ProjectMaterial from '@/pages/projectMaterial' // 项目物料

export const mainMenuTypeDict = {
  基本信息: 'BASE_DATA',
  物料管理: 'GOODS',
  询报价: 'INQUIRY',
  订单管理: 'ORDERS',
  客户开票: 'CUSTOMER_INVOICE',
  开票付款: 'COUNT_MONEY',
  系统管理: 'SYSTEM',
}
export const mainMenuTypeDictInvert = _.invert(mainMenuTypeDict)

export type MainMenuKey = keyof typeof mainMenuTypeDict

export const SUPROUTE = '/srm'

// 信息存redux 切换不会改变数据
const userRouter: RouteListParam[] = [
  {
    title: '登录',
    key: 'Login',
    url: '/login',
    keyName: 'Login',
    exact: true, // 唯一匹配
    component: Loginpage,
  },
  {
    title: '主模块',
    key: 'BasicLayout',
    url: SUPROUTE,
    keyName: 'BasicLayout',
    exact: false, // 唯一匹配
    component: Basiclayout,
    router: [
      {
        title: '主页',
        key: 'home',
        url: '/home',
        keyName: 'home',
        exact: true, // 唯一匹配
        component: Home,
      },
      {
        title: '咸亨公告',
        key: 'xhNotice',
        url: '/xhNotice',
        keyName: 'xhNotice',
        exact: true, // 唯一匹配
        component: XhNotice,
      },
      {
        title: '公告详情',
        key: 'xhNoticeDetail',
        url: '/xhNoticeDetail',
        keyName: 'xhNoticeDetail',
        exact: true, // 唯一匹配
        component: XhNoticeDetail,
      },
      {
        title: '基本信息',
        key: 'baseinfo',
        url: '/baseinfo',
        keyName: 'baseinfo',
        exact: true, // 唯一匹配
        component: Baseinfo,
      },
      {
        title: '消息中心',
        key: 'messageCenter',
        url: '/messageCenter',
        keyName: 'messageCenter',
        exact: true, // 唯一匹配
        component: MessageCenter,
      },
      {
        title: '密码修改',
        key: 'password',
        url: '/password',
        keyName: 'password',
        exact: true, // 唯一匹配
        component: Password,
      },
      {
        title: '项目物料提报管理',
        key: 'materialSubmission',
        keyName: 'materialSubmission',
        url: '/materialSubmission',
        type: 'GOODS',
        exact: true, // 唯一匹配
        cache: true,
        component: MaterialSubmission,
      },
      {
        title: '项目物料',
        key: 'projectMaterial',
        keyName: 'projectMaterial',
        url: '/projectMaterial',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: ProjectMaterial,
      },
      {
        title: '我的物料',
        key: 'goods',
        keyName: 'goods',
        url: '/goods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: Goodslist,
      },
      // 物料信息-非审核模块
      {
        title: '新增物料',
        key: 'addgoods',
        keyName: 'addgoods',
        url: '/addgoods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: Goodsdetail,
      },
      {
        title: '物料信息-编辑',
        key: 'editgoods',
        keyName: 'editgoods',
        url: '/editgoods',
        exact: true, // 唯一匹配
        component: listlaunchgoodsInfo,
      },
      // 物料信息-审核模块
      {
        title: '我发起的-编辑',
        key: 'launchgoodsInfo',
        keyName: 'launchgoodsInfo',
        url: '/launchgoodsInfo',
        exact: true, // 唯一匹配
        component: GoodsdetailLaun,
      },
      // 物料信息-公共模块
      {
        title: '物料信息-详情',
        key: 'goodsdetail',
        keyName: 'goodsdetail',
        url: '/goodsdetail',
        exact: true, // 唯一匹配
        component: Goodauditdetail,
      },
      // 项目商品提报管理-详情
      {
        title: '提报记录-详情',
        key: 'goodsSubmission',
        keyName: 'goodsSubmission',
        url: '/goodsSubmission',
        exact: true, // 唯一匹配
        component: GoodsSubmission,
      },
      // 我的物料-商品提报-详情
      {
        title: '商品提报-详情',
        key: 'goodsSubmissionEdit',
        keyName: 'goodsSubmissionEdit',
        url: '/goodsSubmissionEdit',
        exact: true, // 唯一匹配
        component: GoodsSubmission,
      },

      {
        title: '批量新增',
        key: 'newBatchAdd',
        keyName: 'newBatchAdd',
        url: '/newBatchAdd',
        type: 'GOODS',
        exact: true, // 唯一匹配
        dot: false,
        component: NewBatchAdd,
      },
      {
        title: '待提交物料',
        key: 'toSubmitGoods',
        url: '/toSubmitGoods',
        keyName: 'toSubmitGoods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        number: 0,
        component: ToSubmitGoods,
      },
      {
        title: '我新增的品牌',
        key: 'myBrand',
        url: '/myBrand',
        keyName: 'myBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: MyBrand,
      },
      {
        title: '我的申请',
        key: 'mylaunch',
        keyName: 'mylaunch',
        url: '/mylaunch',
        type: 'GOODS',
        exact: true, // 唯一匹配
        dot: false,
        component: MyLaunch,
      },
      {
        title: '新增品牌',
        key: 'addBrand',
        keyName: 'addBrand',
        url: '/addBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: AddBrand,
      },
      {
        title: '编辑品牌',
        key: 'editBrand',
        keyName: 'editBrand',
        url: '/editBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: EditBrandDetail,
      },
      {
        title: '品牌详情',
        key: 'brandDetail',
        keyName: 'brandDetail',
        url: '/brandDetail',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: BrandDetail,
      },
      // 物料信息-审核模块
      {
        title: '待提交物料-编辑',
        key: 'toSubmitGoodsEdit',
        keyName: 'toSubmitGoodsEdit',
        url: '/toSubmitGoodsEdit',
        exact: true, // 唯一匹配
        component: GoodsdetailLaun,
      },
      {
        title: '订单报备',
        key: 'orderregistration',
        keyName: 'orderregistration',
        url: '/orderregistration',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderRegistration,
      },
      {
        title: '订单履约',
        key: 'orderassurance',
        keyName: 'orderassurance',
        url: '/orderassurance',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderAssurance,
      },
      {
        title: '订单转派',
        key: 'ordertransfer',
        keyName: 'ordertransfer',
        url: '/ordertransfer',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderTransfer,
      },
      // 电商供应商订单详情
      {
        title: '订单详情',
        key: 'orderdetail',
        keyName: 'orderdetail',
        url: '/orderdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: OrderDetail,
      },
      // 供应商订单详情
      {
        title: '订单详情',
        key: 'ordersupplierdetail',
        keyName: 'ordersupplierdetail',
        url: '/ordersupplierdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: OrderSupplierDetail,
      },
      // 电商供应商订单-新增发货单
      {
        title: '新增发货单',
        key: 'adddeliveryorder',
        keyName: 'adddeliveryorder',
        url: '/adddeliveryorder',
        exact: true, // 唯一匹配
        component: AddDeliveryOrder,
      },
      // 供应商订单-新增发货单
      {
        title: '新增发货单',
        key: 'addsupplierdeliveryorder',
        keyName: 'addsupplierdeliveryorder',
        url: '/addsupplierdeliveryorder',
        exact: true, // 唯一匹配
        component: AddSupplierDeliveryOrder,
      },
      {
        title: '发货单详情',
        key: 'deliveryorderdetail',
        keyName: 'deliveryorderdetail',
        url: '/deliveryorderdetail',
        exact: true, // 唯一匹配
        component: DeliveryOrderDetail,
      },
      {
        title: '退货管理',
        key: 'returnmanage',
        url: '/returnmanage',
        keyName: 'returnmanage',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        number: 0,
        component: ReturnManagement,
      },
      {
        title: '退货详情',
        key: 'returnorder',
        url: '/returnorder',
        keyName: 'returnorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnOrder,
      },
      {
        title: '取消详情',
        key: 'cancelorder',
        url: '/cancelorder',
        keyName: 'cancelorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: CancelOrder,
      },
      {
        title: '退货详情',
        key: 'returncancelorder',
        url: '/returncancelorder',
        keyName: 'returncancelorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnCancelOrder,
      },
      {
        title: '取消详情',
        key: 'cancelreturnorder',
        url: '/cancelreturnorder',
        keyName: 'cancelreturnorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnCancelOrder,
      },
      {
        title: '新增报备',
        key: 'filingSheet',
        keyName: 'filingSheet',
        url: '/filingSheet',
        exact: true, // 唯一匹配
        component: FilingSheet,
      },
      {
        title: '新增报备',
        key: 'addReportReceipt',
        keyName: 'addReportReceipt',
        url: '/addReportReceipt',
        exact: true, // 唯一匹配
        component: AddReportReceipt,
      },
      {
        title: '报备详情',
        key: 'reportReceiptDetail',
        keyName: 'reportReceiptDetail',
        url: '/reportReceiptDetail',
        exact: true, // 唯一匹配
        component: AddReportReceipt,
      },
      {
        title: '报备详情',
        key: 'filingSheetDetail',
        keyName: 'filingSheetDetail',
        url: '/filingSheetDetail',
        exact: true, // 唯一匹配
        component: FilingSheet,
      },
      // {
      //   title: `可对账订单`,
      //   key: `reconcilableorders`,
      //   keyName: 'reconcilableorders',
      //   url: `/reconcilableorders`,
      //   type: 'COUNT_MONEY',
      //   exact: true, //唯一匹配
      //   component: ReconcilableOrders,
      // },
      // {
      //   title: `财务对账`,
      //   key: `financialreconciliation`,
      //   keyName: 'financialreconciliation',
      //   url: `/financialreconciliation`,
      //   type: 'COUNT_MONEY',
      //   exact: true, //唯一匹配
      //   component: FinancialReconciliation,
      // },
      {
        title: '待开发票',
        key: 'pendingInvoicePage',
        keyName: 'pendingInvoicePage',
        url: '/pendingInvoicePage',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PendingInvoicePage,
      },
      {
        title: '红字信息表',
        key: 'redNoticePage',
        keyName: 'redNoticePage',
        url: '/redNoticePage',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: RedNoticePage,
      },
      {
        title: '发票录入',
        key: 'invoiceEntry',
        keyName: 'invoiceEntry',
        url: '/invoiceEntry',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: InvoiceEntry,
      },
      {
        title: '红票录入',
        key: 'redInvoiceEntry',
        keyName: 'redInvoiceEntry',
        url: '/redInvoiceEntry',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: RedInvoiceEntry,
      },
      {
        title: '我的发票',
        key: 'myInvoice',
        keyName: 'myInvoice',
        url: '/myInvoice',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: MyInvoice,
      },
      {
        title: '可付款订单',
        key: 'payableorders',
        keyName: 'payableorders',
        url: '/payableorders',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PayableOrders,
      },
      {
        title: '付款申请',
        key: 'paymentrequest',
        keyName: 'paymentrequest',
        url: '/paymentrequest',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PaymentReqauest,
      },
      {
        title: '新增付款申请',
        key: 'addpaymentrequest',
        keyName: 'addpaymentrequest',
        url: '/addpaymentrequest',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: AddPaymentRequest,
      },
      {
        title: '对账单详情',
        key: 'financialreconciliationdetail',
        keyName: 'financialreconciliationdetail',
        url: '/financialreconciliationdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: FinancialReconciliationDetail,
      },
      {
        title: '修改对账单',
        key: 'editFinancialreconciliation',
        keyName: 'editFinancialreconciliation',
        url: '/editFinancialreconciliation',
        exact: true, // 唯一匹配
        component: EditFinancialReconciliation,
      },
      {
        title: '付款申请单',
        key: 'paymentrequestdetail',
        keyName: 'paymentrequestdetail',
        url: '/paymentrequestdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: PaymentRequestDetail,
      },
      {
        title: '新建对账单',
        key: 'addfinancialreconciliation',
        keyName: 'addfinancialreconciliation',
        url: '/addfinancialreconciliation',
        exact: true, // 唯一匹配
        component: AddFinancialReconciliation,
      },
      {
        title: '新增发票',
        key: 'addInvoiceEntry',
        keyName: 'addInvoiceEntry',
        url: '/addInvoiceEntry',
        exact: true, // 唯一匹配
        component: AddInvoiceEntry,
      },
      {
        title: '新增红票',
        key: 'addRedInvoiceEntry',
        keyName: 'addRedInvoiceEntry',
        url: '/addRedInvoiceEntry',
        exact: true, // 唯一匹配
        component: AddRedInvoiceEntry,
      },
      {
        title: '发票详情',
        key: 'invoiceDetail',
        keyName: 'invoiceDetail',
        url: '/invoiceDetail',
        exact: true, // 唯一匹配
        component: InvoiceDetail,
      },
      {
        title: '发票详情',
        key: 'redInvoiceDetail',
        keyName: 'redInvoiceDetail',
        url: '/redInvoiceDetail',
        exact: true, // 唯一匹配
        component: RedInvoiceDetail,
      },
      {
        title: '个人中心',
        key: 'member',
        keyName: 'member',
        url: '/member',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: memberInfo,
      },
      {
        title: '账号管理',
        key: 'accout',
        keyName: 'accout',
        url: '/accout',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: Account,
      },
      {
        title: '组织设置',
        key: 'organizationSettings',
        keyName: 'organizationSettings',
        url: '/organizationSettings',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: OrganizationSettings,
      },
      {
        title: '账号管理-新增',
        key: 'accoutadd',
        keyName: 'accoutadd',
        url: '/accoutadd',
        exact: true, // 唯一匹配
        component: AccountEdit,
      },
      {
        title: '账号管理-编辑',
        key: 'accoutupdate',
        keyName: 'accoutupdate',
        url: '/accoutupdate',
        exact: true, // 唯一匹配
        component: AccountEdit,
      },
      {
        title: '工商信息',
        key: 'xhemployee',
        keyName: 'xhemployee',
        url: '/xhemployee',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: businessInfo,
      },
      {
        title: '收款信息',
        key: 'financial',
        keyName: 'financial',
        url: '/financial',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: financialInfo,
      },
      // {
      //   title: '合作协议',
      //   key: 'cooperation',
      //   keyName: 'cooperation',
      //   url: '/cooperation',
      //   type: 'BASE_DATA',
      //   exact: true, // 唯一匹配
      //   dot: false,
      //   component: cooperationInfo,
      // },
      {
        title: '资质证照',
        key: 'qualifications',
        keyName: 'qualifications',
        url: '/qualifications',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: qualificationsInfo,
      },
      {
        title: '电供协议管理',
        key: 'contract',
        keyName: 'contract',
        url: '/contract',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: contract,
      },
      {
        title: '自营协议管理',
        key: 'selfAgreement',
        keyName: 'selfAgreement',
        url: '/selfAgreement',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: SelfAgreement,
      },
      {
        title: '新增授权',
        key: 'addBrandAuthority',
        keyName: 'addBrandAuthority',
        url: '/addBrandAuthority',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: addBrandAuthority,
      },
      {
        title: '修改授权',
        key: 'updateBrandAuthority',
        keyName: 'updateBrandAuthority',
        url: '/updateBrandAuthority',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: updateBrandAuthority,
      },
      {
        title: '任务中心',
        key: 'taskcenter',
        keyName: 'taskcenter',
        url: '/taskcenter',
        exact: true, // 唯一匹配
        component: Taskcenter,
      },
      {
        title: '任务详情',
        key: 'taskdetail',
        keyName: 'taskdetail',
        url: '/taskdetail',
        exact: true, // 唯一匹配
        component: Taskdetail,
      },
      {
        title: '可开票订单',
        key: 'invoiceorder',
        keyName: 'invoiceorder',
        url: '/invoiceorder',
        type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: OrderInvoice,
      },
      {
        title: '申请开票',
        key: 'addinvoice',
        keyName: 'addinvoice',
        url: '/addinvoice',
        // type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: AddInvoice,
      },
      {
        title: '开票申请',
        key: 'invoiceApplication',
        keyName: 'invoiceApplication',
        url: '/invoiceApplication',
        type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: InvoiceApplication,
      },
      {
        title: '申请详情',
        key: 'invoiceApplicationDetail',
        keyName: 'invoiceApplicationDetail',
        url: '/invoiceApplicationDetail',
        exact: true, // 唯一匹配
        component: InvoiceApplicationDetail,
      },
      {
        title: '客户回款',
        key: 'paymentDetails',
        keyName: 'paymentDetails',
        url: '/paymentDetails',
        exact: true, // 唯一匹配
        component: PaymentDetails,
      },
      {
        title: '库存管理',
        key: 'inventoryManagement',
        keyName: 'inventoryManagement',
        url: '/inventoryManagement',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: InventoryManagement,
      },
      {
        title: '国网物料调价',
        key: 'materialPriceAdjustment',
        keyName: 'materialPriceAdjustment',
        url: '/materialPriceAdjustment',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: MaterialPriceAdjustment,
      },
      {
        title: '提交结果',
        key: 'SubmitResult',
        keyName: 'SubmitResult',
        url: '/submitResult',
        exact: true, // 唯一匹配
        component: SubmitResult,
      },
      {
        title: '咸亨询价单',
        key: 'xhQuotation',
        keyName: 'xhQuotation',
        url: '/xhQuotation',
        type: 'INQUIRY',
        exact: true,
        cache: true,
        component: XhQuotation,
      },
      {
        title: '询价单详情',
        key: 'inquiryDetail',
        keyName: 'inquiryDetail',
        url: '/inquiryDetail',
        type: 'INQUIRY',
        exact: true,
        cache: true,
        refreshOnQueryChange: true,
        component: InquiryDetail,
      },
      {
        title: '待办事项',
        key: 'todoBusiness',
        keyName: 'todoBusiness',
        url: '/todoBusiness',
        exact: true,
        component: TodoList,
      },
    ],
  },
  {
    title: '注册',
    key: 'SupplierRegister',
    url: '/SupplierRegister',
    keyName: 'SupplierRegister',
    exact: true,
    component: supplierRegister,
  },
  {
    title: '物流详情',
    key: 'expressH5',
    url: '/expressH5',
    keyName: 'expressH5',
    exact: true, // 唯一匹配
    component: ExpressH5,
  },
]

export { userRouter }
const baseRouterKey = [
  // 可对账订单
  // 'reconcilableorders',
  'invoiceEntry',
  'payableorders',
  'paymentrequest',
  'toSubmitGoods',
  'newBatchAdd',
  'organizationSettings',
  'pendingInvoicePage',
  'redNoticePage',
  'redInvoiceEntry',
  'xhQuotation',
  'filingSheetDetail',
]
// // 所有路由 key
const route_key = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'erroraudit',
  'endstock',
  'goodspicadd',
  'goodspicedit',
  'allocation',
  'brand',
  'brandaudit',
  'brandendaudit',
  'mybrand',
  'category',
  'attribute',
  'statisincr',
  'statisstock',
  'accout',
  'logdata',
  'organization',
  'department',
  'job',
  'employee',
  'unit',
  'productmanager',
  'examinationtype',
  'authority',
  'role',
  'xhemployee',
  'updateBusinessInfo',
  'member',
  'purchase',
  'coefficeConfig',
  'financial',
  'cooperation',
  'qualifications',
  'contract',
  'selfAgreement',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  // 5.0.0
  // 客户开票
  'invoiceorder',
  'invoiceApplication',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 审核员
const SOURCE_ASSESS_MAN = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'endstock',
  'brand',
  'brandaudit',
  'category',
  'attribute',
  // `statisincr`,
  // `statisstock`,
  'brandendaudit',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 审核经理
const SOURCE_ASSESS_MANAGER = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'endstock',
  'goodspicadd',
  'goodspicedit',
  'brand',
  'brandaudit',
  'category',
  'attribute',
  'brandendaudit',
  'productmanager',
  'examinationtype',
  'coefficeConfig',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 采购员
const SOURCE_PURCHASE_MAN = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'erroraudit',
  'endstock',
  'brand',
  'mybrand',
  'category',
  'attribute',
  'allocation',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]
// 商品助理
const SOURCE_PRODUCT_ASSISTANT = [
  'goods',
  'addgoods',
  'temp',
  'mylaunch',
  'allocation',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'orderdetail',
  'ordersupplierdetail',
  // 可对账订单
  // 'reconcilableorders',
  'myInvoice',
  'invoiceEntry',
  'payableorders',
  'paymentrequest',
  'toSubmitGoods',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
]

// 数据管理员
const SOURCE_DATA_MAN = [
  'home',
  'accout',
  'logdata',
  'organization',
  'department',
  'job',
  'employee',
  'unit',
  'xhemployee',
  'xhemployeedetail',
  'supplier',
  'supplierdetail',
  'customer',
  'customerdetail',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

const list: { [x in RoleTypeParam]: string[] } = {
  SOURCE_ASSESS_MAN: SOURCE_ASSESS_MAN,
  SOURCE_ASSESS_MANAGER: SOURCE_ASSESS_MANAGER,
  SOURCE_PURCHASE_MAN: SOURCE_PURCHASE_MAN,
  SOURCE_DATA_MAN: SOURCE_DATA_MAN,
  SOURCE_PRODUCT_ASSISTANT: SOURCE_PRODUCT_ASSISTANT,
  root: route_key,
}
export const RoleMenu = (param?: RoleTypeParam) => {
  if (param) {
    return list[param]
  }
  return route_key
}
import { RouteListParam } from '../tools/public'
import { RoleTypeParam } from '../tools/util'
import Loginpage from '../pages/login'
import Basiclayout from '../pages/basiclayout'
import Goodslist from '../pages/goodslist'
import ToSubmitGoods from '../pages/toSubmitGoods'
import Account from '../pages/account'
import AccountEdit from '../pages/accountedit'
import Goodsdetail from '../pages/goodsmanage/goodsdetail'
import GoodsSubmission from '../pages/materialSubmissionManage'
import GoodsdetailLaun from '../pages/goodsmanage/detailGoods' // 我发起的-编辑
import Goodauditdetail from '../pages/goodsmanage/goodscheck' // 物料信息-详情
import listlaunchgoodsInfo from '../pages/goodsmanage/listlaunchgoodsInfo' // 物料列表-编辑
import Baseinfo from '../pages/baseinfo'
import Password from '../pages/password'
import Home from '../pages/home'
import memberInfo from '../pages/member-info'
import businessInfo from '../pages/business-info'
import financialInfo from '../pages/financial-info'
// import cooperationInfo from '../pages/cooperation'
import qualificationsInfo from '../pages/qualifications'
import contract from '../pages/contract'
import SelfAgreement from '../pages/self-agreement'
import addBrandAuthority from '../pages/add-brand-authority'
import updateBrandAuthority from '../pages/add-brand-authority'
import supplierRegister from '../pages/supplier-register'
import Taskcenter from '../pages/taskcenter'
import Taskdetail from '../pages/taskdetail'
import OrderAssurance from '../pages/orderassurance'
import OrderTransfer from '../pages/ordertransfer/index'
import ReturnManagement from '../pages/returnmanagement'
import OrderRegistration from '../pages/orderregistration'
// import FinancialReconciliation from '../pages/financialreconciliation'
import OrderDetail from '../pages/orderdetail'
import OrderSupplierDetail from '../pages/orderSupplierDetail'
import AddDeliveryOrder from '../pages/orderdetail/components/AddDeliveryOrder'
import AddSupplierDeliveryOrder from '../pages/orderSupplierDetail/components/AddDeliveryOrder'
import DeliveryOrderDetail from '../pages/orderdetail/components/DeliveryOrderDetail'
import FinancialReconciliationDetail from '../pages/financialreconciliationdetail'
import EditFinancialReconciliation from '../pages/financialreconciliationEdit'
import AddFinancialReconciliation from '../pages/financialreconciliationEdit'
import FilingSheet from '../pages/filing-sheet'
import ReturnOrder from '../pages/return-order'
import CancelOrder from '../pages/cancel-order'
import ReturnCancelOrder from '../pages/returnCancelOrder'
import ExpressH5 from '../pages/expressH5'
import MessageCenter from '../pages/messageCenter'
import _ from 'lodash'
import OrderInvoice from '../pages/order-invoice'
import AddInvoice from '../pages/addinvoice'
// 开票申请
import InvoiceApplication from '../pages/invoiceApplication'
// 开票申请详情
import InvoiceApplicationDetail from '../pages/invoiceApplicationDetail'
// import ReconcilableOrders from '../pages/reconcilable-orders'
import PayableOrders from '../pages/payable-orders'
import AddPaymentRequest from '../pages/add-payment-request'
import PaymentReqauest from '../pages/payment-request'
import PaymentRequestDetail from '../pages/payment-request-detail'
import NewBatchAdd from '../pages/new-batchadd'
import AddReportReceipt from '../pages/add-report-receipt'
import SubmitResult from '../pages/submitMaterial'
import MyBrand from '../pages/myBrand' // 我的品牌
import AddBrand from '../pages/brandmanage/branddetail' // 新增品牌
import BrandDetail from '../pages/brandmanage/branddetail' // 品牌详情
import MyLaunch from '../pages/mylaunch' // 我的申请
import EditBrandDetail from '../pages/brandmanage/branddetail' // 修改品牌
import XhNotice from '../pages/xhNotice' // 咸亨公告
import XhNoticeDetail from '../pages/xhNoticeDetail' // 公告详情
import InvoiceEntry from '../pages/InvoiceEntry' // 发票录入页
import MyInvoice from '../pages/MyInvoice' // 我的发票页
import AddInvoiceEntry from '../pages/AddInvoiceEntry' // 新增发票页
import InvoiceDetail from '../pages/AddInvoiceEntry' // 发票详情页
import PaymentDetails from '../pages/PaymentDetails' // 客户回款明细页
import InventoryManagement from '../pages/InventoryManagement' // 库存管理页面
import MaterialPriceAdjustment from '../pages/MaterialPriceAdjustment' // 国网物料调价页
import PendingInvoicePage from '@/pages/pendingInvoicePage'
import RedNoticePage from '@/pages/redNoticePage'
import OrganizationSettings from '@/pages/organizationSettings'

import MaterialSubmission from '../pages/materialSubmission'
import RedInvoiceEntry from '@/pages/RedInvoiceEntry'
import AddRedInvoiceEntry from '@/pages/AddRedInvoiceEntry'
import RedInvoiceDetail from '@/pages/RedInvoiceDetail'

import XhQuotation from '@/pages/XhQuotation'
import InquiryDetail from '@/pages/inquiryDetail'
import TodoList from '@/pages/todoList'
import ProjectMaterial from '@/pages/projectMaterial' // 项目物料

export const mainMenuTypeDict = {
  基本信息: 'BASE_DATA',
  物料管理: 'GOODS',
  询报价: 'INQUIRY',
  订单管理: 'ORDERS',
  客户开票: 'CUSTOMER_INVOICE',
  开票付款: 'COUNT_MONEY',
  系统管理: 'SYSTEM',
}
export const mainMenuTypeDictInvert = _.invert(mainMenuTypeDict)

export type MainMenuKey = keyof typeof mainMenuTypeDict

export const SUPROUTE = '/srm'

// 信息存redux 切换不会改变数据
const userRouter: RouteListParam[] = [
  {
    title: '登录',
    key: 'Login',
    url: '/login',
    keyName: 'Login',
    exact: true, // 唯一匹配
    component: Loginpage,
  },
  {
    title: '主模块',
    key: 'BasicLayout',
    url: SUPROUTE,
    keyName: 'BasicLayout',
    exact: false, // 唯一匹配
    component: Basiclayout,
    router: [
      {
        title: '主页',
        key: 'home',
        url: '/home',
        keyName: 'home',
        exact: true, // 唯一匹配
        component: Home,
      },
      {
        title: '咸亨公告',
        key: 'xhNotice',
        url: '/xhNotice',
        keyName: 'xhNotice',
        exact: true, // 唯一匹配
        component: XhNotice,
      },
      {
        title: '公告详情',
        key: 'xhNoticeDetail',
        url: '/xhNoticeDetail',
        keyName: 'xhNoticeDetail',
        exact: true, // 唯一匹配
        component: XhNoticeDetail,
      },
      {
        title: '基本信息',
        key: 'baseinfo',
        url: '/baseinfo',
        keyName: 'baseinfo',
        exact: true, // 唯一匹配
        component: Baseinfo,
      },
      {
        title: '消息中心',
        key: 'messageCenter',
        url: '/messageCenter',
        keyName: 'messageCenter',
        exact: true, // 唯一匹配
        component: MessageCenter,
      },
      {
        title: '密码修改',
        key: 'password',
        url: '/password',
        keyName: 'password',
        exact: true, // 唯一匹配
        component: Password,
      },
      {
        title: '项目物料提报管理',
        key: 'materialSubmission',
        keyName: 'materialSubmission',
        url: '/materialSubmission',
        type: 'GOODS',
        exact: true, // 唯一匹配
        cache: true,
        component: MaterialSubmission,
      },
      {
        title: '项目物料',
        key: 'projectMaterial',
        keyName: 'projectMaterial',
        url: '/projectMaterial',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: ProjectMaterial,
      },
      {
        title: '我的物料',
        key: 'goods',
        keyName: 'goods',
        url: '/goods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: Goodslist,
      },
      // 物料信息-非审核模块
      {
        title: '新增物料',
        key: 'addgoods',
        keyName: 'addgoods',
        url: '/addgoods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: Goodsdetail,
      },
      {
        title: '物料信息-编辑',
        key: 'editgoods',
        keyName: 'editgoods',
        url: '/editgoods',
        exact: true, // 唯一匹配
        component: listlaunchgoodsInfo,
      },
      // 物料信息-审核模块
      {
        title: '我发起的-编辑',
        key: 'launchgoodsInfo',
        keyName: 'launchgoodsInfo',
        url: '/launchgoodsInfo',
        exact: true, // 唯一匹配
        component: GoodsdetailLaun,
      },
      // 物料信息-公共模块
      {
        title: '物料信息-详情',
        key: 'goodsdetail',
        keyName: 'goodsdetail',
        url: '/goodsdetail',
        exact: true, // 唯一匹配
        component: Goodauditdetail,
      },
      // 项目商品提报管理-详情
      {
        title: '提报记录-详情',
        key: 'goodsSubmission',
        keyName: 'goodsSubmission',
        url: '/goodsSubmission',
        exact: true, // 唯一匹配
        component: GoodsSubmission,
      },
      // 我的物料-商品提报-详情
      {
        title: '商品提报-详情',
        key: 'goodsSubmissionEdit',
        keyName: 'goodsSubmissionEdit',
        url: '/goodsSubmissionEdit',
        exact: true, // 唯一匹配
        component: GoodsSubmission,
      },

      {
        title: '批量新增',
        key: 'newBatchAdd',
        keyName: 'newBatchAdd',
        url: '/newBatchAdd',
        type: 'GOODS',
        exact: true, // 唯一匹配
        dot: false,
        component: NewBatchAdd,
      },
      {
        title: '待提交物料',
        key: 'toSubmitGoods',
        url: '/toSubmitGoods',
        keyName: 'toSubmitGoods',
        type: 'GOODS',
        exact: true, // 唯一匹配
        number: 0,
        component: ToSubmitGoods,
      },
      {
        title: '我新增的品牌',
        key: 'myBrand',
        url: '/myBrand',
        keyName: 'myBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: MyBrand,
      },
      {
        title: '我的申请',
        key: 'mylaunch',
        keyName: 'mylaunch',
        url: '/mylaunch',
        type: 'GOODS',
        exact: true, // 唯一匹配
        dot: false,
        component: MyLaunch,
      },
      {
        title: '新增品牌',
        key: 'addBrand',
        keyName: 'addBrand',
        url: '/addBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: AddBrand,
      },
      {
        title: '编辑品牌',
        key: 'editBrand',
        keyName: 'editBrand',
        url: '/editBrand',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: EditBrandDetail,
      },
      {
        title: '品牌详情',
        key: 'brandDetail',
        keyName: 'brandDetail',
        url: '/brandDetail',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: BrandDetail,
      },
      // 物料信息-审核模块
      {
        title: '待提交物料-编辑',
        key: 'toSubmitGoodsEdit',
        keyName: 'toSubmitGoodsEdit',
        url: '/toSubmitGoodsEdit',
        exact: true, // 唯一匹配
        component: GoodsdetailLaun,
      },
      {
        title: '订单报备',
        key: 'orderregistration',
        keyName: 'orderregistration',
        url: '/orderregistration',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderRegistration,
      },
      {
        title: '订单履约',
        key: 'orderassurance',
        keyName: 'orderassurance',
        url: '/orderassurance',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderAssurance,
      },
      {
        title: '订单转派',
        key: 'ordertransfer',
        keyName: 'ordertransfer',
        url: '/ordertransfer',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        component: OrderTransfer,
      },
      // 电商供应商订单详情
      {
        title: '订单详情',
        key: 'orderdetail',
        keyName: 'orderdetail',
        url: '/orderdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: OrderDetail,
      },
      // 供应商订单详情
      {
        title: '订单详情',
        key: 'ordersupplierdetail',
        keyName: 'ordersupplierdetail',
        url: '/ordersupplierdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: OrderSupplierDetail,
      },
      // 电商供应商订单-新增发货单
      {
        title: '新增发货单',
        key: 'adddeliveryorder',
        keyName: 'adddeliveryorder',
        url: '/adddeliveryorder',
        exact: true, // 唯一匹配
        component: AddDeliveryOrder,
      },
      // 供应商订单-新增发货单
      {
        title: '新增发货单',
        key: 'addsupplierdeliveryorder',
        keyName: 'addsupplierdeliveryorder',
        url: '/addsupplierdeliveryorder',
        exact: true, // 唯一匹配
        component: AddSupplierDeliveryOrder,
      },
      {
        title: '发货单详情',
        key: 'deliveryorderdetail',
        keyName: 'deliveryorderdetail',
        url: '/deliveryorderdetail',
        exact: true, // 唯一匹配
        component: DeliveryOrderDetail,
      },
      {
        title: '退货管理',
        key: 'returnmanage',
        url: '/returnmanage',
        keyName: 'returnmanage',
        type: 'ORDERS',
        exact: true, // 唯一匹配
        number: 0,
        component: ReturnManagement,
      },
      {
        title: '退货详情',
        key: 'returnorder',
        url: '/returnorder',
        keyName: 'returnorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnOrder,
      },
      {
        title: '取消详情',
        key: 'cancelorder',
        url: '/cancelorder',
        keyName: 'cancelorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: CancelOrder,
      },
      {
        title: '退货详情',
        key: 'returncancelorder',
        url: '/returncancelorder',
        keyName: 'returncancelorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnCancelOrder,
      },
      {
        title: '取消详情',
        key: 'cancelreturnorder',
        url: '/cancelreturnorder',
        keyName: 'cancelreturnorder',
        exact: true, // 唯一匹配
        number: 0,
        refreshOnQueryChange: true,
        component: ReturnCancelOrder,
      },
      {
        title: '新增报备',
        key: 'filingSheet',
        keyName: 'filingSheet',
        url: '/filingSheet',
        exact: true, // 唯一匹配
        component: FilingSheet,
      },
      {
        title: '新增报备',
        key: 'addReportReceipt',
        keyName: 'addReportReceipt',
        url: '/addReportReceipt',
        exact: true, // 唯一匹配
        component: AddReportReceipt,
      },
      {
        title: '报备详情',
        key: 'reportReceiptDetail',
        keyName: 'reportReceiptDetail',
        url: '/reportReceiptDetail',
        exact: true, // 唯一匹配
        component: AddReportReceipt,
      },
      {
        title: '报备详情',
        key: 'filingSheetDetail',
        keyName: 'filingSheetDetail',
        url: '/filingSheetDetail',
        exact: true, // 唯一匹配
        component: FilingSheet,
      },
      // {
      //   title: `可对账订单`,
      //   key: `reconcilableorders`,
      //   keyName: 'reconcilableorders',
      //   url: `/reconcilableorders`,
      //   type: 'COUNT_MONEY',
      //   exact: true, //唯一匹配
      //   component: ReconcilableOrders,
      // },
      // {
      //   title: `财务对账`,
      //   key: `financialreconciliation`,
      //   keyName: 'financialreconciliation',
      //   url: `/financialreconciliation`,
      //   type: 'COUNT_MONEY',
      //   exact: true, //唯一匹配
      //   component: FinancialReconciliation,
      // },
      {
        title: '待开发票',
        key: 'pendingInvoicePage',
        keyName: 'pendingInvoicePage',
        url: '/pendingInvoicePage',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PendingInvoicePage,
      },
      {
        title: '红字信息表',
        key: 'redNoticePage',
        keyName: 'redNoticePage',
        url: '/redNoticePage',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: RedNoticePage,
      },
      {
        title: '发票录入',
        key: 'invoiceEntry',
        keyName: 'invoiceEntry',
        url: '/invoiceEntry',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: InvoiceEntry,
      },
      {
        title: '红票录入',
        key: 'redInvoiceEntry',
        keyName: 'redInvoiceEntry',
        url: '/redInvoiceEntry',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: RedInvoiceEntry,
      },
      {
        title: '我的发票',
        key: 'myInvoice',
        keyName: 'myInvoice',
        url: '/myInvoice',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: MyInvoice,
      },
      {
        title: '可付款订单',
        key: 'payableorders',
        keyName: 'payableorders',
        url: '/payableorders',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PayableOrders,
      },
      {
        title: '付款申请',
        key: 'paymentrequest',
        keyName: 'paymentrequest',
        url: '/paymentrequest',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: PaymentReqauest,
      },
      {
        title: '新增付款申请',
        key: 'addpaymentrequest',
        keyName: 'addpaymentrequest',
        url: '/addpaymentrequest',
        type: 'COUNT_MONEY',
        exact: true, // 唯一匹配
        component: AddPaymentRequest,
      },
      {
        title: '对账单详情',
        key: 'financialreconciliationdetail',
        keyName: 'financialreconciliationdetail',
        url: '/financialreconciliationdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: FinancialReconciliationDetail,
      },
      {
        title: '修改对账单',
        key: 'editFinancialreconciliation',
        keyName: 'editFinancialreconciliation',
        url: '/editFinancialreconciliation',
        exact: true, // 唯一匹配
        component: EditFinancialReconciliation,
      },
      {
        title: '付款申请单',
        key: 'paymentrequestdetail',
        keyName: 'paymentrequestdetail',
        url: '/paymentrequestdetail',
        exact: true, // 唯一匹配
        refreshOnQueryChange: true,
        component: PaymentRequestDetail,
      },
      {
        title: '新建对账单',
        key: 'addfinancialreconciliation',
        keyName: 'addfinancialreconciliation',
        url: '/addfinancialreconciliation',
        exact: true, // 唯一匹配
        component: AddFinancialReconciliation,
      },
      {
        title: '新增发票',
        key: 'addInvoiceEntry',
        keyName: 'addInvoiceEntry',
        url: '/addInvoiceEntry',
        exact: true, // 唯一匹配
        component: AddInvoiceEntry,
      },
      {
        title: '新增红票',
        key: 'addRedInvoiceEntry',
        keyName: 'addRedInvoiceEntry',
        url: '/addRedInvoiceEntry',
        exact: true, // 唯一匹配
        component: AddRedInvoiceEntry,
      },
      {
        title: '发票详情',
        key: 'invoiceDetail',
        keyName: 'invoiceDetail',
        url: '/invoiceDetail',
        exact: true, // 唯一匹配
        component: InvoiceDetail,
      },
      {
        title: '发票详情',
        key: 'redInvoiceDetail',
        keyName: 'redInvoiceDetail',
        url: '/redInvoiceDetail',
        exact: true, // 唯一匹配
        component: RedInvoiceDetail,
      },
      {
        title: '个人中心',
        key: 'member',
        keyName: 'member',
        url: '/member',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: memberInfo,
      },
      {
        title: '账号管理',
        key: 'accout',
        keyName: 'accout',
        url: '/accout',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: Account,
      },
      {
        title: '组织设置',
        key: 'organizationSettings',
        keyName: 'organizationSettings',
        url: '/organizationSettings',
        type: 'SYSTEM',
        exact: true, // 唯一匹配
        component: OrganizationSettings,
      },
      {
        title: '账号管理-新增',
        key: 'accoutadd',
        keyName: 'accoutadd',
        url: '/accoutadd',
        exact: true, // 唯一匹配
        component: AccountEdit,
      },
      {
        title: '账号管理-编辑',
        key: 'accoutupdate',
        keyName: 'accoutupdate',
        url: '/accoutupdate',
        exact: true, // 唯一匹配
        component: AccountEdit,
      },
      {
        title: '工商信息',
        key: 'xhemployee',
        keyName: 'xhemployee',
        url: '/xhemployee',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: businessInfo,
      },
      {
        title: '收款信息',
        key: 'financial',
        keyName: 'financial',
        url: '/financial',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: financialInfo,
      },
      // {
      //   title: '合作协议',
      //   key: 'cooperation',
      //   keyName: 'cooperation',
      //   url: '/cooperation',
      //   type: 'BASE_DATA',
      //   exact: true, // 唯一匹配
      //   dot: false,
      //   component: cooperationInfo,
      // },
      {
        title: '资质证照',
        key: 'qualifications',
        keyName: 'qualifications',
        url: '/qualifications',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: qualificationsInfo,
      },
      {
        title: '电供协议管理',
        key: 'contract',
        keyName: 'contract',
        url: '/contract',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: contract,
      },
      {
        title: '自营协议管理',
        key: 'selfAgreement',
        keyName: 'selfAgreement',
        url: '/selfAgreement',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        dot: false,
        component: SelfAgreement,
      },
      {
        title: '新增授权',
        key: 'addBrandAuthority',
        keyName: 'addBrandAuthority',
        url: '/addBrandAuthority',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: addBrandAuthority,
      },
      {
        title: '修改授权',
        key: 'updateBrandAuthority',
        keyName: 'updateBrandAuthority',
        url: '/updateBrandAuthority',
        type: 'BASE_DATA',
        exact: true, // 唯一匹配
        component: updateBrandAuthority,
      },
      {
        title: '任务中心',
        key: 'taskcenter',
        keyName: 'taskcenter',
        url: '/taskcenter',
        exact: true, // 唯一匹配
        component: Taskcenter,
      },
      {
        title: '任务详情',
        key: 'taskdetail',
        keyName: 'taskdetail',
        url: '/taskdetail',
        exact: true, // 唯一匹配
        component: Taskdetail,
      },
      {
        title: '可开票订单',
        key: 'invoiceorder',
        keyName: 'invoiceorder',
        url: '/invoiceorder',
        type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: OrderInvoice,
      },
      {
        title: '申请开票',
        key: 'addinvoice',
        keyName: 'addinvoice',
        url: '/addinvoice',
        // type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: AddInvoice,
      },
      {
        title: '开票申请',
        key: 'invoiceApplication',
        keyName: 'invoiceApplication',
        url: '/invoiceApplication',
        type: 'CUSTOMER_INVOICE',
        exact: true, // 唯一匹配
        component: InvoiceApplication,
      },
      {
        title: '申请详情',
        key: 'invoiceApplicationDetail',
        keyName: 'invoiceApplicationDetail',
        url: '/invoiceApplicationDetail',
        exact: true, // 唯一匹配
        component: InvoiceApplicationDetail,
      },
      {
        title: '客户回款',
        key: 'paymentDetails',
        keyName: 'paymentDetails',
        url: '/paymentDetails',
        exact: true, // 唯一匹配
        component: PaymentDetails,
      },
      {
        title: '库存管理',
        key: 'inventoryManagement',
        keyName: 'inventoryManagement',
        url: '/inventoryManagement',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: InventoryManagement,
      },
      {
        title: '国网物料调价',
        key: 'materialPriceAdjustment',
        keyName: 'materialPriceAdjustment',
        url: '/materialPriceAdjustment',
        type: 'GOODS',
        exact: true, // 唯一匹配
        component: MaterialPriceAdjustment,
      },
      {
        title: '提交结果',
        key: 'SubmitResult',
        keyName: 'SubmitResult',
        url: '/submitResult',
        exact: true, // 唯一匹配
        component: SubmitResult,
      },
      {
        title: '咸亨询价单',
        key: 'xhQuotation',
        keyName: 'xhQuotation',
        url: '/xhQuotation',
        type: 'INQUIRY',
        exact: true,
        cache: true,
        component: XhQuotation,
      },
      {
        title: '询价单详情',
        key: 'inquiryDetail',
        keyName: 'inquiryDetail',
        url: '/inquiryDetail',
        type: 'INQUIRY',
        exact: true,
        cache: true,
        refreshOnQueryChange: true,
        component: InquiryDetail,
      },
      {
        title: '待办事项',
        key: 'todoBusiness',
        keyName: 'todoBusiness',
        url: '/todoBusiness',
        exact: true,
        component: TodoList,
      },
    ],
  },
  {
    title: '注册',
    key: 'SupplierRegister',
    url: '/SupplierRegister',
    keyName: 'SupplierRegister',
    exact: true,
    component: supplierRegister,
  },
  {
    title: '物流详情',
    key: 'expressH5',
    url: '/expressH5',
    keyName: 'expressH5',
    exact: true, // 唯一匹配
    component: ExpressH5,
  },
]

export { userRouter }
const baseRouterKey = [
  // 可对账订单
  // 'reconcilableorders',
  'invoiceEntry',
  'payableorders',
  'paymentrequest',
  'toSubmitGoods',
  'newBatchAdd',
  'organizationSettings',
  'pendingInvoicePage',
  'redNoticePage',
  'redInvoiceEntry',
  'xhQuotation',
  'filingSheetDetail',
]
// // 所有路由 key
const route_key = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'erroraudit',
  'endstock',
  'goodspicadd',
  'goodspicedit',
  'allocation',
  'brand',
  'brandaudit',
  'brandendaudit',
  'mybrand',
  'category',
  'attribute',
  'statisincr',
  'statisstock',
  'accout',
  'logdata',
  'organization',
  'department',
  'job',
  'employee',
  'unit',
  'productmanager',
  'examinationtype',
  'authority',
  'role',
  'xhemployee',
  'updateBusinessInfo',
  'member',
  'purchase',
  'coefficeConfig',
  'financial',
  'cooperation',
  'qualifications',
  'contract',
  'selfAgreement',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  // 5.0.0
  // 客户开票
  'invoiceorder',
  'invoiceApplication',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 审核员
const SOURCE_ASSESS_MAN = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'endstock',
  'brand',
  'brandaudit',
  'category',
  'attribute',
  // `statisincr`,
  // `statisstock`,
  'brandendaudit',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 审核经理
const SOURCE_ASSESS_MANAGER = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'endstock',
  'goodspicadd',
  'goodspicedit',
  'brand',
  'brandaudit',
  'category',
  'attribute',
  'brandendaudit',
  'productmanager',
  'examinationtype',
  'coefficeConfig',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

// 采购员
const SOURCE_PURCHASE_MAN = [
  'home',
  'baseinfo',
  'password',
  'goods',
  'temp',
  'addgoods',
  'editgoods',
  'editauditInfo',
  'goodsdetail',
  'batchadd',
  'startstock',
  'waitaudit',
  'mylaunch',
  'doneaudit',
  'erroraudit',
  'endstock',
  'brand',
  'mybrand',
  'category',
  'attribute',
  'allocation',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]
// 商品助理
const SOURCE_PRODUCT_ASSISTANT = [
  'goods',
  'addgoods',
  'temp',
  'mylaunch',
  'allocation',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'orderdetail',
  'ordersupplierdetail',
  // 可对账订单
  // 'reconcilableorders',
  'myInvoice',
  'invoiceEntry',
  'payableorders',
  'paymentrequest',
  'toSubmitGoods',
  'myBrand',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
]

// 数据管理员
const SOURCE_DATA_MAN = [
  'home',
  'accout',
  'logdata',
  'organization',
  'department',
  'job',
  'employee',
  'unit',
  'xhemployee',
  'xhemployeedetail',
  'supplier',
  'supplierdetail',
  'customer',
  'customerdetail',
  // 4.0.0订单管理
  'orderassurance',
  'ordertransfer',
  'returnmanage',
  'orderregistration',
  // 'financialreconciliation',
  'myInvoice',
  'orderdetail',
  'ordersupplierdetail',
  'inventoryManagement',
  'materialPriceAdjustment',
  'materialSubmission',
  'projectMaterial',
  'goodsSubmission',
  ...baseRouterKey,
]

const list: { [x in RoleTypeParam]: string[] } = {
  SOURCE_ASSESS_MAN: SOURCE_ASSESS_MAN,
  SOURCE_ASSESS_MANAGER: SOURCE_ASSESS_MANAGER,
  SOURCE_PURCHASE_MAN: SOURCE_PURCHASE_MAN,
  SOURCE_DATA_MAN: SOURCE_DATA_MAN,
  SOURCE_PRODUCT_ASSISTANT: SOURCE_PRODUCT_ASSISTANT,
  root: route_key,
}
export const RoleMenu = (param?: RoleTypeParam) => {
  if (param) {
    return list[param]
  }
  return route_key
}
